import React, { useMemo } from 'react';
import ProjectContext from './ProjectContext';

export const getProjectFromProps = ({ project }) => {
  if (!project) return null;

  return {
    ...project,
    hasStartDate: Boolean(project.startDate),
    hasEndDate: Boolean(project.endDate)
  };
};

const withProjectContextProvider = BaseComponent => props => {
  const { project } = props;
  const contextValues = useMemo(
    () => ({ project: getProjectFromProps({ project }) }),
    [project]
  );

  return (
    <ProjectContext.Provider value={contextValues}>
      <BaseComponent {...props} />
    </ProjectContext.Provider>
  );
};

export default withProjectContextProvider;
